<template>
  <el-drawer
    :title="currentId ? '编辑' : '新增'"
    :visible.sync="showDrawer"
    append-to-body
    direction="rtl"
    size="800px"
    @close="onDrawerClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      class="edit-form"
      label-position="top"
      v-loading="loading"
      :disabled="submitting"
    >
      <LocaleFormTab @change="onLocaleChange">
        <!-- 中文部分 -->
        <template #cn>
          <el-row :gutter="10">
            <el-col :sm="24" :md="8">
              <el-form-item label="中文名称" prop="name.cn">
                <el-input
                  v-model="form.name.cn"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :sm="24" :md="24">
              <el-form-item label="中文描述" prop="description.cn">
                <el-input
                  v-model="form.description.cn"
                  type="textarea"
                  :rows="6"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="国家(中文)" prop="country.cn">
                <el-input
                  v-model="form.country.cn"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="省份(中文)" prop="province.cn">
                <el-input
                  v-model="form.province.cn"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="城市(中文)" prop="city.cn">
                <el-input
                  v-model="form.city.cn"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12">
              <el-form-item label="区域(中文)" prop="region.cn">
                <el-input
                  v-model="form.region.cn"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12">
              <el-form-item label="街道(中文)" prop="street.cn">
                <el-input
                  v-model="form.street.cn"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="24">
              <el-form-item
                label="海报中文文标语(slogan)"
                prop="poster_slogan.cn"
              >
                <el-input
                  v-model="form.poster_slogan.cn"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <!-- 英文部分 -->
        <template #en>
          <el-row :gutter="10">
            <el-col :sm="24" :md="8">
              <el-form-item label="英文名称" prop="name.en">
                <el-input
                  v-model="form.name.en"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :sm="24" :md="24">
              <el-form-item label="英文描述" prop="description.en">
                <el-input
                  v-model="form.description.en"
                  type="textarea"
                  :rows="6"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="国家(英文)" prop="country.en">
                <el-input
                  v-model="form.country.en"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="省份(英文)" prop="province.en">
                <el-input
                  v-model="form.province.en"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="8">
              <el-form-item label="城市(英文)" prop="city.en">
                <el-input
                  v-model="form.city.en"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12">
              <el-form-item label="地区(英文)" prop="region.en">
                <el-input
                  v-model="form.region.en"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12">
              <el-form-item label="街道(英文)" prop="street.en">
                <el-input
                  v-model="form.street.en"
                  placeholder="请输入内容"
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="24">
              <el-form-item label="海报英文标语(slogan)" prop="poster_slogan.en">
                <el-input
                  v-model="form.poster_slogan.en"
                  clearable
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </LocaleFormTab>

      <el-divider content-position="left">以下为通用部分</el-divider>

      <el-row :gutter="10">
        <el-col :sm="24" :md="8">
          <el-form-item label="次序(数值越大越靠前)" prop="seq">
            <el-input-number
              v-model="form.seq"
              label="请输入"
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="8">
          <el-form-item label="类型(多选)" prop="type_ids">
            <el-select
              multiple
              v-model="form.type_ids"
              placeholder="请选择类型"
              class="form-select"
              clearable
            >
              <el-option
                v-for="item in typesOptions"
                :key="item.id"
                :label="item.name.i18n"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="8">
          <el-form-item label="区域" prop="area_id">
            <el-select
              v-model="form.area_id"
              placeholder="请选择区域"
              class="form-select"
              clearable
            >
              <el-option
                v-for="item in areasOptions"
                :key="item.id"
                :label="item.name.i18n"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="8">
          <el-form-item label="设计方" prop="designer_id">
            <el-select
              v-model="form.designer_id"
              placeholder="请选择设计方"
              class="form-select"
              clearable
            >
              <el-option
                v-for="item in designersOptions"
                :key="item.id"
                :label="item.name.i18n"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="8">
          <el-form-item label="开发商" prop="developer_id">
            <el-select
              v-model="form.developer_id"
              placeholder="请选择开发商"
              class="form-select"
              clearable
            >
              <el-option
                v-for="item in developersOptions"
                :key="item.id"
                :label="item.name.i18n"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="8">
          <el-form-item label="拍摄日期" prop="shooting_date">
            <el-date-picker
              class="form-select"
              v-model="form.shooting_date"
              type="date"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="24">
          <el-form-item label="产品(多选)" prop="product_ids">
            <ProductTransfer v-model="form.product_ids" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :sm="24" :md="12">
          <el-form-item label="封面图片" prop="cover_image_url">
            <p class="form-tips">
              提示：该图会用在系列列表的封面图，图片宽除于高的比值保持在1.5，建议900*600同等比例的图，大小保持在1MB左右，越高清越好
            </p>
            <SingleImgUpload
              class="cover-img"
              :size="2"
              v-model="form.cover_image_url"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="海报图" prop="poster_image_url">
            <p class="form-tips">
              提示：用作海报宣传图，建议宽高【1125x2436】等同比例（宽高比0.46）尺寸的图片,建议大小保持在1.5MB以内
            </p>
            <SingleImgUpload
              :size="2"
              class="poster-img"
              v-model="form.poster_image_url"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="图册" prop="images">
        <el-upload
          :disabled="isImagesLoading"
          class="upload-albums"
          ref="albumsUpload"
          :action="onUploadUrl"
          :headers="headers"
          :before-upload="handleImagesBeforeUpload"
          :on-success="handleImagesSuccess"
          :on-error="handleImagesError"
          :auto-upload="true"
          :show-file-list="false"
          :multiple="true"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
            :icon="isImagesLoading ? 'el-icon-loading' : 'el-icon-upload2'"
            :disabled="isImagesLoading"
            >{{ isImagesLoading ? "上传中..." : "选取文件" }}</el-button
          >
          <div slot="tip" class="el-upload__tip">
            <p>限制文件类型为jpeg、jpg、png</p>
            <p>
              图片尺寸比例建议1.2，计算方式为宽度除于高度，例如262/215，图片大小尽量保持在1MB以内
            </p>
          </div>
        </el-upload>
        <DraggbleSort syncSortKey v-model="form.images" class="file-list-wrap">
          <template v-slot:default="slotProps">
            <div class="file-item">
              <div class="image-wrapper">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="slotProps.item.url"
                  :preview-src-list="form.images.map((item) => item.url)"
                >
                </el-image>
              </div>
              <div
                class="delete-btn"
                @click="handleRemoveImages(slotProps.index)"
              >
                <i class="el-icon-delete"></i>
              </div>
              <div class="darg-btn">
                <i class="el-icon-rank"></i>
              </div>
            </div>
          </template>
        </DraggbleSort>
      </el-form-item>

      <el-form-item style="text-align: right">
        <el-button @click="onRefreshOptions">刷新选单</el-button>
        <el-button @click="onResetForm('form')">重 置</el-button>
        <el-button
          v-if="currentId"
          type="warning"
          @click="submitEidtForm('form')"
          :loading="submitting"
          >{{ submitting ? "保存中..." : "保存" }}</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="submitForm('form')"
          :loading="submitting"
          >{{ submitting ? "保存中..." : "保存" }}</el-button
        >
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { GetCasesById, PostCases, PutCases } from "../api";
import { ShowApiError } from "@/request/error";
import SingleImgUpload from "@/components/SingleImgUpload";
import API_CONFIG from "@/request/api.config";
import { getToken } from "@/utils/auth";
import DraggbleSort from "@/components/DraggbleSort";
import LocaleFormTab from "@/components/LocaleFormTab";
import ProductTransfer from "@/views/products/components/ProductTransfer";
import options from "../mixins/options";
import form from "../mixins/form";
import _lodash from "lodash";
// import { buildI18nKeyValue } from "@/utils/common";
export default {
  props: {
    sid: {
      type: [String, Number],
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [options, form],
  components: {
    SingleImgUpload,
    DraggbleSort,
    LocaleFormTab,
    ProductTransfer,
  },
  data() {
    return {
      currentLocalName: "cn",
      currentId: null,
      loading: false,
      submitting: false,
      showDrawer: false,
      isAlbumsLoading: false,
      isFileLoading: false,
      isImagesLoading: false,
      form: {},
      rules: {
        "name.cn": [{ required: true, message: "请输入", trigger: "blur" }],
        "name.en": [{ required: true, message: "请输入", trigger: "blur" }],
        // "country.cn": [
        //   { required: true, message: "请输入国家中文", trigger: "blur" },
        // ],
        // "country.en": [
        //   { required: true, message: "请输入国家英文", trigger: "blur" },
        // ],
        // "province.cn": [
        //   { required: true, message: "请输入省份/州中文", trigger: "blur" },
        // ],
        // "province.en": [
        //   { required: true, message: "请输入省份/州英文", trigger: "blur" },
        // ],
        // "city.cn": [
        //   { required: true, message: "请输入城市中文", trigger: "blur" },
        // ],
        // "city.en": [
        //   { required: true, message: "请输入城市英文", trigger: "blur" },
        // ],
        product_ids: [
          { required: true, message: "请选择产品", trigger: "change" },
        ],
        type_ids: [{ required: true, message: "请选择类型", trigger: "change" }],

        seq: [
          {
            required: true,
            message: "请输入次序",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  computed: {
    headers() {
      return {
        Authorization: getToken(),
      };
    },
    onUploadUrl() {
      return API_CONFIG.BASE_V1_API + "/oss/upload/cdn";
    },
    localeColumns() {
      return this.$store.getters.localeColumns;
    },
    predefineColors() {
      return this.$store.getters.predefineColors;
    },
  },
  watch: {
    sid: {
      handler(value) {
        if (value !== null) {
          this.currentId = value;
        } else {
          this.currentId = null;
          this.initForm();
        }
      },
      immediate: true,
    },
    show: {
      handler(value) {
        this.showDrawer = value;
        if (this.currentId) {
          this.getFormData();
        }
        if (this.showDrawer) {
          this.initFormOptions();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.initForm();
    this.initFormOptions();
  },
  methods: {
    onLocaleChange(e) {
      let name = e.name;
      this.currentLocalName = name;
    },
    handleImagesBeforeUpload(file) {
      let allowType = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowType.includes(file.type)) {
        this.$message.error(`上传的图片格式不合法,格式需要为jpeg/jpg/png`);
        return false;
      }
      this.isImagesLoading = true;
      return true;
    },
    handleImagesSuccess(response, file) {
      this.form.images.push({
        name: {
          cn: file.name,
          en: file.name,
        },
        url: file.response.data ? file.response.data : "",
        seq: this.form.images.length + 1,
      });
      this.isImagesLoading = false;
      this.$message.success(`文件${file.name}上传成功`);
    },
    handleImagesError(err, file) {
      console.error(err);
      this.$message.error(`文件${file.name}上传失败`);
      this.isImagesLoading = false;
    },
    handleRemoveImages(index) {
      this.form.images.splice(index, 1);
    },

    buildFormParams() {
      let datas = _lodash.cloneDeep(this.form);
      if (datas.shooting_date == "") {
        datas.shooting_date = null;
      }
      return datas;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PostCases([this.buildFormParams()])
            .then(() => {
              this.$message.success("保存成功!");
              this.initForm();
              this.submitting = false;
              this.emitSucccess();
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError("保存错误", err);
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    submitEidtForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PutCases([
            {
              id: this.currentId,
              ...this.buildFormParams(),
            },
          ])
            .then(() => {
              this.$message.success("保存成功!");
              this.initForm();
              this.submitting = false;
              this.getFormData();
              this.emitSucccess();
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError("保存错误", err);
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    getFormData() {
      this.loading = true;
      GetCasesById(this.currentId)
        .then((res) => {
          this.form = this.buildEditFormData(res.data);
          this.loading = false;
        })

        .catch((err) => {
          this.loading = false;
          ShowApiError("获取表单数据失败", err);
        });
    },
    // buildFormItem() {
    //   return {
    //     name: { ...this.localeColumns },
    //     description: { ...this.localeColumns },
    //     country: { ...this.localeColumns },
    //     province: { ...this.localeColumns },
    //     city: { ...this.localeColumns },
    //     region: { ...this.localeColumns },
    //     street: { ...this.localeColumns },
    //     type_ids: [],
    //     product_ids: [],
    //     poster_image_url: "",
    //     poster_slogan: { ...this.localeColumns },
    //     cover_image_url: "",
    //     shooting_date: null,
    //     developer_id: null,
    //     designer_id: null,
    //     area_id: null,
    //     images: [
    //       // {
    //       //   url:"",
    //       //   seq:0
    //       // }
    //     ],
    //     vgc_engineering_case_id: null,
    //     seq: 1,
    //   };
    // },
    initForm() {
      this.form = {
        ...this.buildForm(),
      };
      this.$nextTick(() => {
        if (this.$refs["form"]) {
          this.$refs["form"].resetFields();
        }
      });
    },
    onCancel() {
      this.initForm();
      this.emitFail();
    },
    onResetForm() {
      this.$confirm("确定要重置表单吗?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.currentId) {
            this.getFormData();
          } else {
            this.initForm();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onRefreshOptions() {
      this.initFormOptions();
      this.$message.success("已刷新");
    },
    onDrawerClose() {
      this.showDrawer = false;
      this.$emit("close", this.showDrawer);
    },
    emitSucccess() {
      this.$emit("success");
    },
    emitFail() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.form-select {
  width: 100%;
}
.medias-list-wrap {
  display: inline-block;
  max-width: 100%;
  ::v-deep {
    .transition-el {
      max-height: none;
    }
  }

  .medias-item {
    display: block;
    width: 100px;
    height: 100px;
    margin: 5px;
  }
  .video-medias-item {
    box-sizing: border-box;
    padding: 5px 0;
    margin: 5px;
    width: 280px;
    height: 100px;
    position: relative;
    padding-right: 20px;
    background-color: #edfae8;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .remove-video-icon {
      position: absolute;
      bottom: 5px;
      right: 2px;
      font-size: 16px;
      cursor: pointer;
      color: #c51515;
    }
    ::v-deep {
      .basic-upload-wrap {
        width: 150px;
        height: 90px;
      }
      .img-upload-wrap {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.add-madias-item {
  display: block;
  width: 100%;
  height: 40px;
  font-size: 30px;
  margin: 0 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}
.poster-img {
  width: 150px;
  height: 326px;
}
.edit-form {
  padding: 0 20px;
}
.form-tips {
  font-size: 12px;
  margin: 0;
  color: #989898;
}
.cover-img {
  width: 300px;
  height: 200px;
}
.file-list-wrap {
  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  max-width: 100%;
  min-height: 300px;
  border: 1px dashed #f1f1f1;
  background-color: #fffdfc;
  ::v-deep {
    .transition-el {
      box-sizing: border-box;
      width: 100%;
      padding-right: 10px;
    }
    .draggable-item {
      width: 100%;
    }
  }
  .file-item {
    box-sizing: border-box;
    width: 100%;
    height: 120px;
    padding: 10px 50px;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    position: relative;
    gap: 10px;
    border: 1px solid #f1f1f1;
    color: #989898;
    overflow: hidden;

    .darg-btn {
      width: 40px;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateY(-50%);
      font-size: 20px;
      color: inherit;
      cursor: move;
    }
    .delete-btn {
      width: 40px;
      position: absolute;
      top: 50%;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translateY(-50%);
      font-size: 20px;
      color: inherit;
      cursor: pointer;
      &:hover {
        color: #ff3d3d;
      }
    }
    &:hover {
      // color: #fff;
      // background-color: hsl(15, 88%, 55%);
      border: 1px solid hsl(15, 88%, 55%);
      .darg-btn {
        color: #fff;
        background-color: hsl(15, 88%, 55%);
      }
    }
    .image-wrapper {
      box-sizing: border-box;
      padding: 4px;
      flex: 130px 0 0;
      height: 100%;
      border: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 56px;
      overflow: hidden;
      color: #ff3d3d;
      align-self: start;
      background-color: #f7f5f5;
      a {
        color: inherit;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      ::v-deep {
        .el-image {
          background-color: transparent;
        }
        .el-image__inner {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .file-content {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
